import { useTheme, useMediaQuery } from '@mui/material';
import ChatListPageDesktop from './ChatListPageDesktop';
import ChatListPageMobile from './ChatListPageMobile';

export default function ChatListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <ChatListPageMobile />
    : <ChatListPageDesktop />;
}